// @flow

import {
  CHATBOT_EVENTS,
  type ChatchampChatbotCompleted,
  type MoreProductsLoadedEventPayload
} from '../types'

function setProducts ({ detail: eventPayload }: { detail: ChatchampChatbotCompleted }) {
  window.chatchamp.products = eventPayload.products
}

function appendProducts ({ detail: eventPayload }: { detail: MoreProductsLoadedEventPayload }) {
  window.chatchamp.products = window.chatchamp.products.concat(eventPayload.products)
}

export function registerChatchampPixelListeners (): void {
  window.addEventListener(CHATBOT_EVENTS.Completed, setProducts)
  window.addEventListener(CHATBOT_EVENTS.MoreProductsLoaded, appendProducts)
}

// only for testing
export function unregisterChatchampPixelListeners (): void {
  window.addEventListener(CHATBOT_EVENTS.Completed, setProducts)
  window.addEventListener(CHATBOT_EVENTS.MoreProductsLoaded, appendProducts)
}
